/**
 * ehr#571 (PROGRESS_NOTE_10-20-V141 V127): the "Search or add an intervention" box on Interventions
 * used. Typing lists the practice's interventions not ticked yet that contain the words; one not on
 * the list can be added (it goes on the practice list and is ticked).
 */
export const INTERVENTION_MAX_LEN = 60;
export const INTERVENTION_LIST_MAX = 60;

const norm = (s: string) => s.replace(/\s+/g, ' ').trim();

export interface InterventionSearch {
  /** Not ticked yet and matching every word typed, best first (starts with the text). */
  matches: string[];
  /** The list's own spelling of what was typed, when it is already on the list. */
  exact: string | null;
  /** What "Add" would add: the typed text, tidied; null when there is nothing to add. */
  add: string | null;
}

/**
 * ehr#682 (V141 V127): `hidden` are the ones Show / hide keeps off this client's checklist. Search
 * still finds them and lists them first.
 */
export function searchInterventions(
  list: readonly string[],
  ticked: readonly string[],
  query: string,
  hidden: readonly string[] = [],
): InterventionSearch {
  const q = norm(query);
  if (!q) return { matches: [], exact: null, add: null };
  const lq = q.toLowerCase();
  const words = lq.split(' ');
  const exact = list.find((x) => x.toLowerCase() === lq) ?? null;
  const matches = list
    .filter((x) => !ticked.includes(x))
    .filter((x) => words.every((w) => x.toLowerCase().includes(w)))
    .sort(
      (a, b) =>
        Number(!hidden.includes(a)) - Number(!hidden.includes(b)) ||
        Number(!a.toLowerCase().startsWith(lq)) - Number(!b.toLowerCase().startsWith(lq)) ||
        a.localeCompare(b),
    )
    .slice(0, 8);
  const tickedExact = ticked.some((x) => x.toLowerCase() === lq);
  const add = exact || tickedExact || q.length > INTERVENTION_MAX_LEN ? null : q;
  return { matches, exact, add };
}
